import { BaseWebComponentDataProvider } from '../../../../../framework/BaseWebComponentDataProvider';
import { IntegrityMonitorRealTimePanelWebComponentSchema } from '../types';

export class IntegrityMonitorRealTimePanelBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IntegrityMonitorRealTimePanelWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
